/**
 * Constants for BorrowerRep component
 */

import { RepFormErrors } from "./types";

/**
 * Initial empty error state
 */
export const INITIAL_ERRORS: RepFormErrors = {
  representative_first_name: "",
  representative_last_name: "",
  repEmail: "",
  userFirstName: "",
  userLastName: "",
  representative_title: "",
  merchantTitle: "",
  shareholderDirector: "",
};

/**
 * Default director title
 */
export const DIRECTOR_TITLE = "Director";
